import { z } from 'zod';

export const StockTableData = z.object({
  productId: z.string(),
  deviceName: z.string(),
  minStockLevel: z.number(),
  maxStockLevel: z.number(),
  recMinStockLevel: z.number().optional(),
  recMaxStockLevel: z.number().optional(),
  sku: z.string().optional(),
  inStock: z.number().optional()
});

export interface StockTableData extends z.infer<typeof StockTableData> {}
